enum SampleDataActionTypes {
  SET_SIMPLE_SAMPLE = "SET_SIMPLE_SAMPLE",
  SET_REGULAR_SAMPLE = "SET_REGULAR_SAMPLE",
  SET_COMPLEX_SAMPLE = "SET_COMPLEX_SAMPLE",
}

export default SampleDataActionTypes;
